
export * from '../../frontend-js-react-web/__liferay__/exports/react-dom$client.js';
